import React, { createContext, useContext, useRef } from 'react';

const ScrollPositionContext = createContext();

export const useScrollPosition = () => {
  const context = useContext(ScrollPositionContext);
  if (!context) {
    throw new Error('useScrollPosition must be used within a ScrollPositionProvider');
  }
  return context;
};

export const ScrollPositionProvider = ({ children }) => {
  const scrollRefs = useRef({});

  const saveScrollPosition = (key, position) => {
    try {
      localStorage.setItem(`scroll-${key}`, position.toString());
    } catch (error) {
      console.warn('Erro ao salvar posição do scroll:', error);
    }
  };

  const getScrollPosition = (key) => {
    try {
      const saved = localStorage.getItem(`scroll-${key}`);
      return saved ? parseInt(saved, 10) : 0;
    } catch (error) {
      console.warn('Erro ao obter posição do scroll:', error);
      return 0;
    }
  };

  const setScrollRef = (key, ref) => {
    scrollRefs.current[key] = ref;
  };

  const restoreScrollPosition = (key) => {
    try {
      const ref = scrollRefs.current[key];
      const position = getScrollPosition(key);
      
      if (ref && ref.current && position > 0) {
        ref.current.scrollTop = position;
      }
    } catch (error) {
      console.warn('Erro ao restaurar posição do scroll:', error);
    }
  };

  const clearScrollPosition = (key) => {
    try {
      localStorage.removeItem(`scroll-${key}`);
    } catch (error) {
      console.warn('Erro ao limpar posição do scroll:', error);
    }
  };

  return (
    <ScrollPositionContext.Provider
      value={{
        saveScrollPosition,
        getScrollPosition,
        setScrollRef,
        restoreScrollPosition,
        clearScrollPosition
      }}
    >
      {children}
    </ScrollPositionContext.Provider>
  );
};
